import * as React from 'react';

import { createIcon } from '../Icon';
export const ChevronUpIcon = createIcon(
  <polyline points="18 15 12 9 6 15" />,
  'ChevronUpIcon'
);
